export default __webpack_public_path__ + "static/media/intro_to_git_and_github.b4c2514a.jpeg";